import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import * as _ from "lodash";
import { getDateObject } from "./components/shared/DateConversions";

import translationEN from "./locales/en/translation.en.json";
import translationDE from "./locales/de/translation.de.json";
import translationZH from "./locales/zh/translation.zh.json";
import translationPL from "./locales/pl/translation.pl.json";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  zh: {
    translation: translationZH,
  },
  pl: {
    translation: translationPL,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      // order and from where user language should be detected
      order: ["querystring", "navigator", "cookie", "localStorage", "sessionStorage", "htmlTag", "path", "subdomain"],
    },
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function (value, format, lng) {
        if (format === "intlDate" && value) {
          const date = getDateObject(value);
          return `${date?.toLocaleDateString(lng)} ${date?.toLocaleTimeString(lng)}`;
        }
        if (format === "intlDateShort" && value) {
          const date = getDateObject(value);
          return date?.toLocaleDateString(lng);
        }
        if (format === "lowercase") return value.toLowerCase();
        if (format === "upperFirst") return _.upperFirst(value.toLowerCase());
        if (format === "intlNumber") return new Intl.NumberFormat(lng).format(Number(value));
        return value;
      },
    },
    react: {
      useSuspense: false,
    },
  });

i18n.changeLanguage();

export default i18n;
